/** Display helpers local to the reports feature (§9.5). */

/**
 * Human-readable byte size: bytes as integers, KB/MB/GB with one decimal
 * (wireframe: `1.2 MB`, `48 KB`). `undefined`/invalid renders nothing so the
 * "· size" segment simply drops out.
 */
export function formatBytes(bytes?: number): string {
  if (bytes === undefined || !Number.isFinite(bytes) || bytes < 0) {
    return '';
  }
  if (bytes < 1024) {
    return `${Math.round(bytes)} B`;
  }
  const units = ['KB', 'MB', 'GB'] as const;
  let value = bytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(1)} ${units[unitIndex]}`;
}

/** `cmk_ab12…`-style shortening for the duplicate's primary id (§9.4: first 8 chars). */
export function shortenId(id: string, length = 8): string {
  return id.length > length ? `${id.slice(0, length)}…` : id;
}

/**
 * Panel counts line (§6.1/§7): "{n} environments · {n} reports · {n} known
 * issues" with natural singular forms (wireframe: "1 environment").
 */
export function plural(count: number, word: string): string {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}

export function summaryLine(counts: {
  environments: number;
  reports: number;
  activeKnownIssues: number;
}): string {
  return (
    `${plural(counts.environments, 'environment')} · ` +
    `${plural(counts.reports, 'report')} · ` +
    `${plural(counts.activeKnownIssues, 'known issue')}`
  );
}
